import { API_AUTH } from "./common";

const DanhSachMauThuChiApi = {
  list: ({
    sContractName,
    isKeyword,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `QuanLyMauThuChi/danhsach?PageIndex=${pageIndex}&PageSize=${pageSize}&sContractName=${sContractName}&isKeyword=${isKeyword}`,
      {}
    ),
    update: (data) =>
    API_AUTH.post(`QuanLyMauThuChi/addorupdate`, data),
    
};



export default DanhSachMauThuChiApi;
